module.exports = __webpack_public_path__ + "redmine-logo.png";